import { withStyles } from '@material-ui/core';

import Zoomable from './component';
import styles from './styles';

export default withStyles(styles)(Zoomable);
